import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { environment } from '@tv3/environments/environment'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AuthService } from '@tv3/services/auth.service'
import * as lodash from 'lodash'
@Component({
  selector: 'app-acm-dashboard-promo-dialog',
  templateUrl: './acm-dashboard-promo-dialog.component.html',
  styleUrls: ['./acm-dashboard-promo-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class AcmDashboardPromoDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<AcmDashboardPromoDialogComponent>,
    private authService: AuthService,
    private amp: AmplitudeService
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  goToACM(path: string) {
    this.amp.logEvent('acm-dashboard-promo-item-clicked')
    this.amp.logEvent('acm-dashboard-promo-item-clicked-' + lodash.snakeCase(path))
    window.open(`${environment.acmAppUrl}/login?token=${this.authService.token}&redirectURL=${path}`, '_blank')
  }
}
